import { ButtonTheme, type NavigationItem } from 'api/contentful/contentTypes.cloverdotcom';
import type { FlatEntry } from 'services/cms/flattenContentful';

export function useOverrideButtonUtilItems(
  isNavBarTransparent?: boolean,
  buttonUtilItems: Array<FlatEntry<NavigationItem>> = [],
) {
  if (!isNavBarTransparent) return buttonUtilItems;
  return buttonUtilItems.map(item => ({ ...item, buttonTheme: ButtonTheme.IMAGE, buttonOutline: true }));
}
